module.exports = __webpack_public_path__ + "static/aravind-aad25d44b3776d1a02701a4b8176290e.png";